<app-ptrab-two-factor-card
  actionsPosition="center"
  title="TWO_FACTOR.NEW_PHONE.ADVICE.TITLE"
  imageSrc="assets/imgs/ptrab/contact_coordinator.svg"
  [buttons]="buttons">
  <span class="contact-card__text">{{ 'TWO_FACTOR.NEW_PHONE.ADVICE.SUBTITLE' | mTranslate }}</span>
</app-ptrab-two-factor-card>
